import React, { memo, useEffect, useState } from 'react';
import { Col, FormGroup, Input, Row } from 'reactstrap';

import { showMsg } from '../../services/library';
// import AuthService from '../../services/authService';
import CustomModal from '../../components/GeneralForm/CustomModal';
import CustomSelect from '../../components/GeneralForm/CustomSelect';
import DealerService from '../../services/dealerService';

const OpDecalsModal = props => {
  const { activeDealersList, dealer, opDecalsToggle, handleFullLayoutLoader, modalTrigger } = props;

  const [currentIndex, setCurrentIndex] = useState('');
  const [dealerId, setDealerId] = useState(0);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');

  useEffect(() => {
    setDealerId(dealer?.value || 0);
  }, [dealer, opDecalsToggle]);

  // on change of current dealer
  useEffect(() => {
    if (dealerId && opDecalsToggle) {
      let index = activeDealersList.findIndex(opt => opt.value === dealerId);
      if (index >= 0) {
        setCurrentIndex(index);
      }
    }
  }, [activeDealersList, dealerId, opDecalsToggle]);

  const validate = () => {
    const dId = parseInt(dealerId);
    const fname = firstName?.trim();
    const lName = lastName?.trim();
    const errMSG = [];

    if (!dId) {
      errMSG.push('Dealer is required.');
    }
    if (!fname) {
      errMSG.push('Firstname is required.');
    }
    if (!lName) {
      errMSG.push('Lastname is required.');
    }

    if (errMSG.length > 0) {
      showMsg(errMSG, 'error');
      return false;
    }
    return true;
  };

  const closeModal = () => {
    modalTrigger();
    setDealerId(0);
    setFirstName('');
    setLastName('');
    setCurrentIndex('');
  };

  const saveOpDecals = data => {
    handleFullLayoutLoader(true);
    DealerService.orderStickers(data)
      .then(response => {
        if (response.status) {
          showMsg(response.message, 'success');
          closeModal();
        } else {
          return showMsg(response.errors, 'error');
        }
      })
      .catch(error => {
        showMsg(error, 'error');
      })
      .finally(() => {
        handleFullLayoutLoader(false);
      });
  };

  const submittedData = () => {
    if (validate()) {
      saveOpDecals({
        dealer_id: dealerId,
        first_name: firstName,
        last_name: lastName
      });
    }
  };

  return (
    <CustomModal
      isOpen={opDecalsToggle}
      closeClick={closeModal}
      modalSize="md"
      saveClick={submittedData}
      modalTitle="Order Progress Decals"
      submitButtonName="Send"
    >
      <div className="d-flex mb-4">
        <span className="ml-auto align-self-start small">
          <span className="text-danger">*</span>
          Required Field
        </span>
      </div>
      <Row>
        <Col>
          <FormGroup row>
            <Col>
              <CustomSelect
                id="dId"
                options={activeDealersList}
                selected={currentIndex < 0 ? '' : activeDealersList[currentIndex]}
                onChange={dealer => {
                  setDealerId(dealer?.value);
                }}
                placeholder={`Select Dealership`}
                size="md"
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col>
              <Input
                type="text"
                name="fname"
                id="fname"
                maxLength="80"
                value={firstName}
                onChange={e => setFirstName(e.target.value)}
                placeholder="Enter Firstname"
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col>
              <Input
                type="text"
                name="lname"
                id="lname"
                maxLength="80"
                value={lastName}
                onChange={e => setLastName(e.target.value)}
                placeholder="Enter Lastname"
              />
            </Col>
          </FormGroup>
        </Col>
      </Row>
    </CustomModal>
  );
};

OpDecalsModal.displayName = 'OpDecalsModal';
export default memo(OpDecalsModal);
